import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import Theme from './theme';
export var RichTextTheme = Theme;
/*::
import type { Node } from 'react';
import type { StyledComponent } from 'styled-components';
import type { RichTextThemeType } from './theme';

type Props = {|
  children: Node;
  theme?: RichTextThemeType,
  "data-test"?: string,
  rest?: any,
|};
*/

var RichText = function RichText(_ref
/*: Props */
, ref) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? Theme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "theme"]);

  return /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    ref: ref
  }, rest), children);
};

export default /*#__PURE__*/React.forwardRef
/*:: <Props, ?HTMLDivElement> */
(RichText);